var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('v-btn',{attrs:{"height":_vm.btnHeight,"max-height":_vm.btnHeight,"color":"success","elevation":"0"},on:{"click":_vm.onCall}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v(" mdi-phone-outline")]),_vm._v(" Call now ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }